import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FlashService } from './flash.service';

@Injectable({
  providedIn: 'root'
})
export class ButtonExecutionService {

    constructor(private http: HttpClient, private flashService: FlashService) { }

    RunMethod(method, data, id) {
        var requestStr = id ? '/api/ButtonExecution/' + method + '/?id=' + id : '/api/ButtonExecution/' + method;
        return this.http.post(requestStr, data).toPromise().then(this.handleSuccess, this.handleError.bind(this));
    }

    private handleSuccess(res) {
        return { success: true, data: res };
    }

    private handleError(res) {
        this.flashService.Error(res.error.errors.toString(), false);
        return { success: false };
    }
}
